import type { UserActivityLevel } from '../services/user-activity.service';
import { ICON_PATHS, typeMeta } from '../lib/activityMeta';

export function ActivityIcon({ type, level }: { type: string; level: UserActivityLevel }) {
  const m = typeMeta(type);
  const tone =
    level === 'error' ? 'bg-red-100 text-red-600' : level === 'warning' ? 'bg-amber-100 text-amber-700' : m.tone;
  return (
    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${tone}`}>
      <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8} aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" d={ICON_PATHS[m.icon]} />
      </svg>
    </span>
  );
}

export function LevelBadge({ level }: { level: UserActivityLevel }) {
  if (level === 'info') return null;
  const cls = level === 'error' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-800';
  return (
    <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${cls}`}>
      {level === 'error' ? 'Errore' : 'Avviso'}
    </span>
  );
}
